/**
 * Whether to show the friend-collage "masked photo pending" UI instead of the stored fox-mask cutout image.
 * Uses persisted `friendFoxMaskPlaceholder` when set; legacy posters fall back on survey `user_photo`.
 */
export function showFriendFoxMaskPlaceholder(poster) {
  if (!poster?.friendCollageShare) return false;
  if (poster.friendFoxMaskPlaceholder === false) return false;
  if (poster.friendFoxMaskPlaceholder === true) return true;
  return !poster.surveyAnswers?.user_photo;
}
